import { gpHome } from '../../app';
import { IUibModalInstance, ModalService } from '../../../app-common/services/bootstrap-ui-modal';

import { feedback } from '../../../app-common/util/logger';
import { CurrentUserService } from '../../../app-common/services/current-user-service';
import gpCancelSubscriptionDialogTemplate from './gp-cancel-subscription-dialog.html';

export interface gpCancelSubscriptionDialogOptions {
    endDate: string;
}

export interface gpCancelSubscriptionDialogResult {
    formData: any;
}

interface gpCancelSubscriptionDialogScope {
    endDate: string;
    currentStep: 'askFeedback' | 'confirmCancellation';

    feedbackValid: boolean;

    formDataChanged(newData: any): void;
    formError(reason: any): void;

    next(): void;
    cancel(): void;
}

gpHome.directive('gpFormioForm', [
    '$http',
    '$timeout',
    function (
        $http: ng.IHttpService,
        $timeout: ng.ITimeoutService,
    ) {

        return ({
            restrict: 'E',
            scope: {
                src: '@',
                formChanged: '&',
                formError: '&',
            },
            link: ($scope: ng.IScope & any,
                instanceElement: ng.IAugmentedJQuery,
                attrs: ng.IAttributes) => {

                const shouldAutoFocus = !!attrs.autoFocus;
                const scope: gpCancelSubscriptionDialogScope = $scope;
                console.log($scope);
                console.log(instanceElement);
                console.log(attrs);

                $http.get<Object>($scope.src, {
                    responseType: "application/json"
                })
                    .then(async (response) => {

                        const formioModule = await import(/* webpackChunkName: "formiojs" */ "formiojs");

                        console.log("got respoonse", response)
                        console.log("creating form", instanceElement.get(0), response.data)
                        formioModule.Formio.createForm(instanceElement.get(0), response.data)
                            .then(form => {
                                if (shouldAutoFocus) {
                                    var firstInputElement = form.element.querySelector('input[type="text"],textarea')

                                    if (firstInputElement) {
                                        firstInputElement.focus();
                                    }
                                }

                                form.on('change', function () {
                                    const dataCopy = {
                                        ...form.data,
                                        isValid: form.isValid(),
                                    }

                                    $timeout(() => {
                                        if ($scope.formChanged) {
                                            $scope.formChanged({ newData: dataCopy });
                                        }
                                    }, 10);
                                });
                            }).catch(reason => {
                                $timeout(() => {
                                    if ($scope.formError) {
                                        $scope.formError({ reason: reason });
                                    }
                                }, 10);


                            })
                    })
                    .catch(reason => {
                        $scope.formError({ reason: "" });
                    })

            },
            template: '<div></div>',
        });
    }
]);

gpHome.controller('gpCancelSubscriptionDialog',
    ['$scope', '$uibModalInstance', 'options',
        CurrentUserService.serviceName,

        function (
            $scope: gpCancelSubscriptionDialogScope & ng.IScope,
            $uibModalInstance: IUibModalInstance<gpCancelSubscriptionDialogResult>,
            options: gpCancelSubscriptionDialogOptions,
            gpCurrentUserService: CurrentUserService,

        ) {
            let formData: any = {};

            $scope.endDate = options.endDate;
            $scope.currentStep = 'askFeedback';
            $scope.feedbackValid = false;

            $scope.next = () => {
                if ($scope.currentStep === 'askFeedback') {
                    $scope.currentStep = 'confirmCancellation';
                    gpCurrentUserService.sendFeedback({ context: 'cancellation form', ...formData })
                        .then(url => {
                        })
                        .catch(reason => {
                        });

                } else if ($scope.currentStep === 'confirmCancellation') {
                    let result: gpCancelSubscriptionDialogResult = {
                        formData: formData,
                    };

                    $uibModalInstance.close(result);
                } else {
                    $scope.currentStep = 'askFeedback';
                }
            }

            $scope.formDataChanged = (newData) => {
                $scope.$apply(() => {
                    formData = newData;
                    $scope.feedbackValid = !!newData.isValid;
                })
            }

            $scope.formError = function (reason) {
                $scope.$apply(() => {
                    $scope.currentStep = 'confirmCancellation';
                    $scope.feedbackValid = true;

                    formData = {
                        'formError': reason,
                    }
                });
            }

            $scope.cancel = () => {
                $uibModalInstance.dismiss('cancel');
            };

        }]);

export class CancelSubscriptionDialogService {
    static $inject = ['gpModal'];

    constructor(private readonly modalService: ModalService) {
    }

    showDialog(options: gpCancelSubscriptionDialogOptions): ng.IPromise<gpCancelSubscriptionDialogResult> {

        const modalInstance = this.modalService.open<gpCancelSubscriptionDialogResult>({
            animation: true,
            template: gpCancelSubscriptionDialogTemplate,
            controller: 'gpCancelSubscriptionDialog',
            backdrop: true,
            backdropClass: 'gameplan-gp-cancel-subscription-dialog',
            windowClass: 'gameplan-gp-cancel-subscription-dialog',
            resolve: {
                options: () => options,
            },
        });

        return modalInstance.result;
    }
}

gpHome.service('gpCancelSubscriptionDialogService', CancelSubscriptionDialogService);
